import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

import {
  IonModal,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonButton,
  IonTitle,
  IonContent,
  IonItem,
  IonLabel,
  IonFooter,
  IonList,
  IonSelect,
  IonSelectOption,
} from "@ionic/react";
import Spacer from "components/spacer";

import { WSemit } from "services/socket";
import { updateProgress } from "services/quiz";

interface props {
  setModalOpen: any;
  modalOpen: boolean | undefined;
  quizConfig: any;
  updateProgress: Function;
  progress: any;
}

const JumpToModal: React.FC<props> = ({
  setModalOpen,
  modalOpen,
  quizConfig,
  updateProgress,
  progress,
}) => {
  const defaultState = {
    section: "question",
    page: "question",
    round: progress.round || 1,
    position: 0,
  };
  const [position, setPosition] = useState(defaultState);
  const navigate = useHistory();

  const onWillDismiss = (ev: any) => {
    setModalOpen(false);
    setPosition(defaultState);
  };

  const onSelectChange = (e: any) => {
    let field = e.target.name;
    let value = e.target.value;
    if (field === "section") {
      if (value === "result") {
        position.page = "round";
      } else {
        position.page = "question";
      }
      if (value === "winner") {
        position.round = quizConfig.format.rounds;
      }
      if (value === "breaker") {
        position.page = "answer-question";
        position.round = 5;
      }
    }
    setPosition({ ...position, [field]: value });
  };

  useEffect(() => {
    if (progress) {
      setPosition({ ...position, round: progress.round });
    }
    //eslint-disable-next-line
  }, [progress]);

  const onGo = () => {
    WSemit("updateProgress", {
      location: "jumpModal",
      ...progress,
      ...position,
      output: { mode: "quiz", page: 0 },
    });
    updateProgress(position);
    setModalOpen(false);
    navigate.push("/quiz");
    setPosition(defaultState);
  };

  const getRoundsOptions = () => {
    let rounds = [];
    for (let i = 0; i < quizConfig.format.rounds; i++) {
      rounds.push(
        <IonSelectOption key={i} value={i + 1}>
          {i + 1}
        </IonSelectOption>
      );
    }
    return rounds;
  };

  const getQuestionsOptions = () => {
    let rounds = [];
    for (let i = 0; i < quizConfig.format.questionCount; i++) {
      rounds.push(
        <IonSelectOption key={i} value={i}>
          {i + 1}
        </IonSelectOption>
      );
    }
    return rounds;
  };

  const hasCrossword = quizConfig.format.isCrossword;
  const hasBreaker = quizConfig.format.hasBreaker;

  return (
    <IonModal
      isOpen={modalOpen}
      // trigger="open-select-modal"
      onWillDismiss={onWillDismiss}
      style={{ padding: "15px" }}
    >
      <IonHeader>
        <IonToolbar>
          <IonTitle>Jump To</IonTitle>

          <IonButtons slot="end">
            <IonButton onClick={onWillDismiss} color="light">
              Cancel
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding">
        <Spacer size="15" />
        <IonList>
          <IonItem>
            <IonLabel position="floating">Jump To</IonLabel>
            <IonSelect
              name="section"
              placeholder="Select type"
              value={position.section}
              interface="popover"
              onIonChange={onSelectChange}
            >
              <IonSelectOption value="question">Question</IonSelectOption>
              <IonSelectOption value="answer">Answer</IonSelectOption>
              {hasCrossword && (
                <IonSelectOption value="crossword">Crossword</IonSelectOption>
              )}
              {hasBreaker && (
                <IonSelectOption value="breaker">Breaker</IonSelectOption>
              )}
              <IonSelectOption value="result">Results</IonSelectOption>
              <IonSelectOption value="winner">Winner</IonSelectOption>
            </IonSelect>
          </IonItem>
          <Spacer size="15" />
          {(position.section === "question" ||
            position.section === "answer" ||
            position.section === "crossword" ||
            position.section === "result") && (
            <>
              <IonItem>
                <IonLabel position="floating">Round</IonLabel>
                <IonSelect
                  name="round"
                  value={position.round}
                  placeholder="Select Round"
                  interface="popover"
                  onIonChange={onSelectChange}
                >
                  {quizConfig && getRoundsOptions()}
                </IonSelect>
              </IonItem>
              <Spacer size="15" />
            </>
          )}
          {(position.section === "question" ||
            position.section === "answer") && (
            <>
              <IonItem>
                <IonLabel position="floating">Position</IonLabel>
                <IonSelect
                  name="position"
                  value={position.position}
                  placeholder="Select Position"
                  interface="popover"
                  onIonChange={onSelectChange}
                >
                  {quizConfig && getQuestionsOptions()}
                </IonSelect>
              </IonItem>
            </>
          )}
        </IonList>
      </IonContent>

      <IonFooter>
        <IonItem>
          <IonButtons slot="end">
            <IonButton color="primary" onClick={onGo}>
              GO
            </IonButton>
          </IonButtons>
        </IonItem>
      </IonFooter>
    </IonModal>
  );
};

const mapStateToProps = (state: any) => ({
  quizConfig: state.quiz.quizConfig,
  progress: state.quiz.progress,
});

export default connect(mapStateToProps, { updateProgress })(JumpToModal);
